<template>
  <v-layout column>
    <v-layout
      fill-height
      align-center
    >
      <span class="subheading px-2">Сообщения</span>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            small
            icon
            :disabled="isDisabledAdd"
            v-on="on"
            @click="dialog = true"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Добавить сообщение</span>
      </v-tooltip>
      <v-dialog
        v-model="dialog"
        persistent
        width="500"
      >
        <v-card>
          <v-card-text>
            <v-form>
              <v-tooltip
                v-if="tooltip"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-textarea
                    v-model="comment"
                    label="Сообщение"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <span>{{ tooltip }}</span>
              </v-tooltip>
              <v-textarea
                v-else
                v-model="comment"
                label="Сообщение"
              />
              <v-btn
                small
                color="primary"
                :loading="loading"
                :disabled="!comment"
                @click="save"
              >
                Добавить
              </v-btn>
              <v-btn
                small
                @click="closeDialog"
              >
                Отмена
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout class="pa-1 auto-height-list">
      <v-list>
        <v-list-tile
          v-for="(comment, index) in comments"
          :key="index"
          class="compact pb-1"
          :class="!comment.isReaded ? 'blue lighten-5' : ''"
        >
          <v-list-tile-content>
            <div>
              <span
                class="grey--text text--darken-1"
              >{{ comment.author.title }}: {{ comment.createdAt | dateTime }}
              </span>
              <span> {{ comment.text }}</span>
              <span
                v-if="comment.readedDate"
                class="grey--text"
              >
                {{
                  `(Прочитано: ${$options.filters.dateTime(
                    comment.readedDate
                  )})`
                }}</span>
              <v-icon
                small
                color="grey darken-1"
                class="ml-2 mr-1"
                :disabled="comment.disabled"
                @click="activeActionDialog(comment.id)"
              >
                delete
              </v-icon>
            </div>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-layout>
    <app-action-confirm
      :value="actionDialog"
      text="Вы действительно хотите удалить сообщение?"
      @cancel="actionDialog = false"
      @confirm="remove"
    />
  </v-layout>
</template>

<script>
export default {
  props: {
    comments: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: "",
    },
    isDisabledAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      comment: "",
      tmpCommentId: 0,
      actionDialog: false,
    };
  },
  computed: {
    unreadCommentsLength() {
      return this.comments.filter(c => !c.isReaded).length;
    },
    unreadCommentsId() {
      return this.comments
        .filter(c => !c.isReaded)
        .map(c => {
          return c.id;
        });
    },
  },
  methods: {
    save() {
      if (!this.comment) {
        return;
      }
      this.$emit("add", this.comment);
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.comment = "";
    },
    remove() {
      this.$emit("delete", this.tmpCommentId);
      this.actionDialog = false;
    },
    activeActionDialog(commentId) {
      this.tmpCommentId = commentId;
      this.actionDialog = true;
    },
  },
};
</script>

<style>
.auto-height-list {
  max-height: 210px;
  height: auto;
  overflow: auto;
}
</style>
